export default {
      id: "ic-euro-total-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-euro-total-usage",
      toString: function () {
        return this.url;
      }
    }